import { getCsrfToken } from '../lib/utils'

export const create = async (userId, gameId, roleType) => {
  const response = await fetch(`/games/${gameId}/game_roles`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken()
    },
    body: JSON.stringify({
      user_id: userId,
      role_type: roleType
    })
  })

  if (!response.ok) {
    const error = await response.json()
    throw new Error(error.error || 'Failed to create game role')
  }

  return response.json()
}

export const destroy = async (roleId, gameId) => {
  const response = await fetch(`/games/${gameId}/game_roles/${roleId}`, {
    method: 'DELETE',
    headers: {
      'X-CSRF-Token': getCsrfToken()
    }
  })

  if (!response.ok) {
    const error = await response.json()
    throw new Error(error.error || 'Failed to destroy game role')
  }

  return response.json()
}

export const index = async (gameId) => {
  const response = await fetch(`/games/${gameId}/game_roles`, {
    headers: {
      'X-CSRF-Token': getCsrfToken()
    }
  })

  if (!response.ok) {
    const error = await response.json()
    throw new Error(error.error || 'Failed to fetch game roles')
  }

  return response.json()
}